import React, { useState, useEffect, useContext } from 'react';
import AuthContext from './Auth/Authprovider';
import Logo from "../images/logo.png";
import '../App.css';
import Navbar from './Navbar';
import axios from 'axios';
import DataTable from './DataTable';
import NewDataModal from './NewDataModal';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ReportTable from './ReportsTable';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [reportsdate, setReportsData] = useState([]);
  const [dataformopen, setDataFormOpen] = useState(false);
  const { authTokens,logoutUser, user } = useContext(AuthContext);


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchData = async () => {
    setLoading(true);
 
    try {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/api/data-entry/',
        headers: { 'Authorization': `Bearer ${authTokens.access}` }
      };
      const response = await axios.request(config);
      setData(response.data);
   
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const fetchReports = async () => {
    setLoading(true);

   
    try {
     
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/api/reports/',
        headers: { 'Authorization': `Bearer ${authTokens.access}` }
      };
      const response = await axios.request(config);
      setReportsData(response.data);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };


  const closeModal=()=>{
    setDataFormOpen(false)
  }
  const openModal=()=>{
    setDataFormOpen(true)
  }

  useEffect(() => {


    fetchData();
    fetchReports();
  }, []);

  return (
    <>
      <Navbar user={user} logoutUser={logoutUser} accessToken={authTokens.access}/>
      <div className='App'>
        <NewDataModal isOpen={dataformopen} onClose={closeModal} fetchData={fetchData} accessToken={authTokens.access}/>
        <div className='App-header bg-white text-dark p-3'>

          {loading ? (
            <div className='view p-3 mt-4  text-center text-success'>
              <div >
                <div className="spinner-border" role="status">
                  <span className="sr-only ml-5">Loading...</span>
                </div>
                <p className='text-muted'><small>Processing upload....</small></p>
              </div>
            </div>
          ) : (
            <>
                  <br /> <br />
              
                 <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="PHYSICAL REGISTRY DATA" {...a11yProps(0)} />
                            <Tab label="PROJECT REPORT" {...a11yProps(1)} />

                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      <DataTable data={data} openModal={openModal} fetchData={fetchData} accessToken={authTokens.access}/>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <ReportTable data={reportsdate} fetchReports={fetchReports} accessToken={authTokens.access}/>
                    </CustomTabPanel>

                </Box>
             
            </>
          
          )}
        </div>
      </div>
    </>
  );
};

export default Home;



